var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { StorageService } from '../../storage.service';
import { HttpService } from '../../common/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SettingsService } from '../../settings/settings.service';
var CustomerFormService = /** @class */ (function () {
    function CustomerFormService(httpService, storage, settings, _http) {
        this.httpService = httpService;
        this.storage = storage;
        this.settings = settings;
        this._http = _http;
        this.header = new HttpHeaders();
        this.header = this.header.append('Content-Type', 'application/json');
    }
    CustomerFormService.prototype.AddMerchants = function (data) {
        return this.httpService.post('/formeditor', data);
    };
    CustomerFormService.prototype.listMerchants = function (data) {
        return this.httpService.get('/formeditor/all', data);
    };
    CustomerFormService.prototype.deleteMerchants = function (data) {
        return this.httpService.delete('/formeditor', data);
    };
    CustomerFormService.prototype.editMerchants = function (data) {
        return this.httpService.put('/formeditor', data);
    };
    CustomerFormService.prototype.handleError = function (error) {
        return Observable.throw(error);
    };
    CustomerFormService.prototype.deleteImage = function (data) {
        return this.httpService.post('/fileremove', data);
    };
    // All Forms
    CustomerFormService.prototype.getMerchantSettings = function () {
        return this.httpService.get('/formeditor/all', null);
    };
    //partcular form
    CustomerFormService.prototype.getCustomFormSettings = function (data) {
        return this.httpService.get('/formeditor', data);
    };
    CustomerFormService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpService, StorageService, SettingsService,
            HttpClient])
    ], CustomerFormService);
    return CustomerFormService;
}());
export { CustomerFormService };



//////////////////
// WEBPACK FOOTER
// ./src/app/settings/customer-form/customer-form.service.ts
// module id = ./src/app/settings/customer-form/customer-form.service.ts
// module chunks = main